// pages/Edit.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IEquipment from '../interfaces/IEquipment';

export default function Edit() {
  const { register, handleSubmit, control, setValue: setFormValue, getValues } = useForm<IEquipment>();
  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string', placeholder: 'Equipment Name', required: true },
    { name: 'code', type: 'string', placeholder: 'Code', required: true },
    { name: 'serial_number', type: 'string', placeholder: 'Serial Number', required: true },
    { name: 'equipment_group_id', type: 'selectAutoComplete', model: 'equipment-group', placeholder: 'Equipment Group', required: true },
  ];

  return (
    <CrudEdit
      model={'equipment'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={'Equipment successfully updated!'}
      title={'Edit equipment'}
      getValues={getValues}
    />
  );
}
